<template>
  <AdminModal
    :confirm-button-title="`생성`"
    :modal-title="`결제상품 등록`"
    :is-open="isOpen" 
    :confirm="save"
    :close="close"
    name="productModal"
  >
    <div class="py-2 px-2">
      <label for="title" class="form-label">상품명</label>
      <input type="text"
             class="form-control"
             placeholder="상품명을 입력해주세요"
             id="title"
             v-model="title"
      />
      <label for="amount" class="form-label pt-2">상품 가격</label>
      <input type="number"
             class="form-control"
             placeholder="0"
             id="title"
             v-model="amount"
      />
    </div>
  </AdminModal>
</template>

<script>
import api from "@/api/api";
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "ProductModal",
  components: {AdminModal},
  props: ['isOpen', 'close', 'id', 'reload'],
  data(){
    return {
      title: '',
      amount: 0,
    }
  },
  methods: {
    validate(){
      if (this.title.length === 0){
        alert('상품명을 입력하세요.')
        return false
      }
      
      if (this.amount == 0) {
        alert('상품가격을 입력하세요.')
        return false
      }

      const regExp = /[0-9]/g;
      if(!regExp.test(this.amount)){
        alert('슷지민 입력하세요')
        return false
      }
        
      return true
    },
    save(){
      if(this.validate()) {
        let params = {
          title: this.title,
          amount: this.amount
        }
        api.product.save(params, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>